/* Create by Lzy 2020.06.09*/
'use strict';
angular.module('addTenantModule', [])
    .controller('addTenantCtrl', ['$scope', '$timeout', 'trsHttpService', 'modalDialog', '$modalInstance', 'options', 'globleParamsSet', function($scope, $timeout, trsHttpService, modalDialog, $modalInstance, options, globleParamsSet) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                searchWordLeft: '',
                userSelectedList: [],
                title: options.title
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description] 请求租户列表数据
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var params = {
                CurrPage: 1,
                methodname:	'queryTenantsByCategory',
                PageSize: 100,
                serviceid: 'mlf_tenant',
                status: '0'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.userDatas = data.DATA;
                initSelectedList();
            });
        }

        /**
         * [initSelectedList description]
         *
         * @return  {[type]}  [return description]
         */
        function initSelectedList() {
            angular.forEach($scope.data.userDatas, function(data) {
                var flag = true;
                angular.forEach(options.selected, function(_data, _index, _array) {
                    if (data.TENANTID === _data.OBJID) {
                        flag = false;
                    }
                });
                if (!flag) {
                    $scope.data.userSelectedList.push(data);
                }
            });
        }
        // 输入过滤器
        $scope.myFilter = function(expected, actual) {
            var flag = true;
            if ($scope.data.searchWordLeft !== '' && angular.isDefined($scope.data.searchWordLeft)) {
                flag = expected.TENANTNAME.indexOf($scope.data.searchWordLeft) >= 0;
            }
            return flag;
        };
        // 双击选择
        $scope.dbckChoose = function(user) {
            delete user.selected;
            $scope.data.userSelectedList = contrast([angular.copy(user)], angular.copy($scope.data.userSelectedList), 'TENANTID');
        };
        // 双击撤销
        $scope.dbckRemove = function(user) {
            $scope.data.userSelectedList = removeList([angular.copy(user)], angular.copy($scope.data.userSelectedList), 'TENANTID');
        };

        // 单击选择
        $scope.singleSelect = function() {
            var selectedArray = [];
            angular.forEach(angular.copy($scope.data.userDatas), function(data, index, array) {
                if (data.selected) {
                    if (angular.isDefined(data.selected)) {
                        $scope.data.userDatas[index].selected = false;
                        delete data.selected;
                    }
                    selectedArray.push(data);
                }
            });
            $scope.data.userSelectedList = contrast(selectedArray, angular.copy($scope.data.userSelectedList), 'TENANTID');
        };
        // 单击撤销
        $scope.singleRemove = function() {
            var removeArray = [];
            angular.forEach(angular.copy($scope.data.userSelectedList), function(data, index, array) {
                if (data.selected) {
                    if (angular.isDefined(data.selected)) {
                        $scope.data.userSelectedList[index].selected = false;
                        delete data.selected;
                    }
                    removeArray.push(data);
                }
            });
            $scope.data.userSelectedList = removeList(removeArray, angular.copy($scope.data.userSelectedList), 'TENANTID');
        };

        /**
         * [selectedAll description] 全选
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectedAll = function() {
            angular.forEach($scope.data.userDatas, function(data, index, array) {
                if (angular.isDefined(data.selected)) {
                    delete $scope.data.userDatas[index].selected;
                }
            });
            $scope.data.userSelectedList = contrast(angular.copy($scope.data.userDatas), angular.copy($scope.data.userSelectedList), 'TENANTID');
        };
        $scope.removeAll = function() {
            $scope.data.userSelectedList = [];
        };
        $scope.confirm = function() {
            if ($scope.data.userSelectedList.length !== 0) {
                $modalInstance.close($scope.data.userSelectedList);
            } else {
                modalDialog.alertType('', '请选择租户', 'warning', false);
            }

        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [contrast description]默认展开树函数结束 ，对比是否重复开始
         *
         * @param   {[type]}  array1     [array1 description]
         * @param   {[type]}  array2     [array2 description]
         * @param   {[type]}  attribute  [attribute description]
         *
         * @return  {[type]}             [return description]
         */
        function contrast(array1, array2, attribute) {
            angular.forEach(array1, function(data, index, array) {
                var flag = true;
                if ($scope.data.searchWordLeft && data.TENANTNAME.indexOf($scope.data.searchWordLeft) === -1) {
                    flag = false;
                } else {
                    angular.forEach(array2, function(_data, _index, _array) {
                        if (data[attribute] === _data[attribute]) {
                            flag = false;
                        }
                    });
                }
                if (flag) {
                    array2.push(data);
                }
            });
            return array2;
        }

        /**
         * [removeList description]对比是否重复结束
         *
         * @param   {[type]}  array1     [array1 description]
         * @param   {[type]}  array2     [array2 description]
         * @param   {[type]}  attribute  [attribute description]
         *
         * @return  {[type]}             [return description]
         */
        function removeList(array1, array2, attribute) {
            angular.forEach(array1, function(data, index, array) {
                var i = 0;
                while (i < array2.length) {
                    if (data[attribute] === array2[i][attribute]) {
                        array2.splice(i, 1);
                    } else {
                        i++;
                    }
                }
            });
            return array2;
        }
    }]);
